<template lang="pug">
    v-dialog( persistent max-width="1200px" v-model="open" )
        v-toolbar( color="primary" dark sticky flat )
            v-toolbar-title Generar libro mayor
            v-spacer
            v-btn( icon dark @click="toggleOpen")
                v-icon close
        
        crud-form(
            :fields="fields"
            @submitForm="submitGenerateLedger"
            submitText="Generar"
            ref="refCFGenerateLedger"
            )
</template>

<script>
import { CrudForm } from '@/components/reusable_components'
import { mapActions, mapState } from 'vuex'
import FieldsGenerateLedger from './FieldsGenerateLedger'
import { generateLedger } from '@/services/api/ledger'
//- 
export default {
    name: 'generate-ledger',
    // props: {},
    data: function(){
        return {
            open: false,
            fields: FieldsGenerateLedger,
        }
    },
    computed: {
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),
    },
    methods: {
        // -- UI Modification
        submitGenerateLedger: async function() {
            this.resetSnackbarState()            
            let obj = {}
            obj.g_branch_office_id = null
            obj.init_date = this.$refs.refCFGenerateLedger.vmodels.init_date
            obj.end_date = this.$refs.refCFGenerateLedger.vmodels.end_date
            obj.g_branch_office_id = this.$refs.refCFGenerateLedger.vmodels.g_branch_office_id
            if (obj.init_date !== "" && obj.end_date !== "") {
                if ( obj.init_date > obj.end_date ) {
                    this.showSnackbar( 'error', 'Error', 'La fecha de inicio no puede ser mayor a la fecha de termino' )
                } else {
                    let response = await generateLedger(obj)
                    //-
                    if(response.status == 'success'){
                        let payload = this.fillSnack('success', 'Libro mayor generado correctamente', '')
                        this.initSnackbar(payload)
                        this.$emit('success')
                        this.toggleOpen()
                    }
                    else{
                        let payload = this.fillSnack('error', 'Error', response.error)
                        this.initSnackbar(payload)
                    }        
                }
            }
            else{
                this.showSnackbar( 'warning', 'Acción inválida', 'Complete los campos' )
            }
            
        },
        toggleOpen: function() {
            this.open = !this.open
            this.$refs.refCFGenerateLedger.vmodels = []
        },
        // -- Data fetching
        // -- Data handling and transformations
        // -- Validations and Error handling
        showSnackbar: function(type, title, message) {
            this.initSnackbar(this.fillSnack(type, title, message))
        },
        // -- Other functions
        // -- Vuex mappings
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
    },
    // watch: {},
    components: {
        'crud-form': CrudForm,
    },
    // mixins: [],
    // filters: {},
    // -- Lifecycle Methods
    // -- End Lifecycle Methods
}
</script>

<style lang="scss">
    
</style>